import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { DataFile } from '../../students/virtual-classroom/evaluations/interfaces/evaluation.file.interface';
import { setLoadedFile } from '../reducers/customizationReducer';

export const uplloadFilesTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['AcademicRequests'],
});
// Define a service using a base URL and expected endpoints
export const uploadFilesApi = uplloadFilesTags.injectEndpoints({
  endpoints: (builder) => ({
    /*Solicitudes especiales*/
    /**
     * @POST save especial request
     */
    uploadFiles: builder.mutation<
      string,
      {
        profileId?: number;
        files: File;
      }
    >({
      queryFn: async ({ profileId, files }, { getState, dispatch }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const form = new FormData();
          form.append('files[]', files);
          // form.append('type_document', String(otherAcademicRequestPayload.type_document));
          form.append('user_profile_id', String(user_profile_id));

          const { data } = await mainApi.post<string>('/applications/others/upload/files', form, {
            onUploadProgress: (progressEvent) => {
              const { loaded: thisLoaded } = progressEvent;

              setTimeout(() => dispatch(setLoadedFile(thisLoaded)), 250);
            },

            headers: { 'Content-Type': 'multipart/form-data' },
          });

          dispatch(setLoadedFile(0));

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'AcademicRequests', id: 'LIST' }],
    }),

    /**
     *
     * @POST ADD FILE POST
     * !TODO: componente sin usar, se debe cambiar el type_document id por la keyword (sin back end)
     */
    addFileBucket: builder.mutation<
      DataFile[],
      {
        PayloadFile: File | null;
        typeDocKey: string;
      }
    >({
      queryFn: async ({ PayloadFile, typeDocKey }) => {
        try {
          const form = new FormData();
          form.append('files[]', PayloadFile || '');
          form.append('type_document', typeDocKey);

          const { data: result } = await mainApi.post(`/upload/`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          return { data: result };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUploadFilesMutation } = uploadFilesApi;
